<template>
  <div>
    <el-dropdown-item>
      <span @click="gerenzhongxin">个人中心</span>
    </el-dropdown-item>
    <el-dialog title="个人中心" :visible.sync="dialogTableVisible" append-to-body width="80%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="单位名称" prop="companyName" width="150px"></el-table-column>
        <el-table-column label="内部锁号" prop="innerEncryptNo" width="150px"></el-table-column>
        <el-table-column label="产品详情" prop="module"></el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="props">
            <a
              :href="props.row.rauFileUrl"
              id="rauget"
              style="text-decoration:none;color: #409EFF;font-weight:700;"
            >许可文件</a>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      tableData: [],
      formData: {},
      dialogTableVisible: false,
    };
  },
  methods: {
    gerenzhongxin() {
      this.tableData = [];
      this.formData = {};
      this.dialogTableVisible = true;
      this.$http
        .post(this.$getaxiosurl("/enc/trial/getEncryptRecord"))
        .then((response) => {
          if (response.data.code == "00100") {
            for (let l = 0; l < response.data.data.length; l++) {
              this.tableData.push(response.data.data[l]);
            }
          }
        });
    },
  },
};
</script>
<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>